import {motion} from "framer-motion";
import {Box, BoxProps} from "@chakra-ui/react";

export const MotionBox = motion<BoxProps>(Box);